import { useMemo } from 'react'

import { useQuery } from 'react-query'

import { userRepository } from '@webapp/platform/iam/data-access/repositories/UserRepository'
import { userKeys } from '@webapp/platform/iam/data-access/repositories/UserRepository/queryKey.factory'
import { type DetailedUser } from '@webapp/platform/iam/entities/DetailedUser'
import { UserPurchasePriceLimit } from '@webapp/platform/iam/entities/UserPurchasePriceLimit'

type UseQueryUserPurchasePriceLimitReturn = {
  data: {
    purchasePriceLimit: UserPurchasePriceLimit
  }
  states: {
    isFetching: boolean
  }
}

export const useQueryUserPurchasePriceLimit = ({
  userId,
}: {
  userId: DetailedUser['id']
}): UseQueryUserPurchasePriceLimitReturn => {
  const { data, isFetching } = useQuery({
    queryKey: [...userKeys.purchasePriceLimit, userId],
    queryFn: () => userRepository.getPurchasePriceLimit(userId),
  })

  const { purchasePriceLimit } = useMemo(() => {
    if (!data) return { purchasePriceLimit: undefined }
    return {
      purchasePriceLimit: new UserPurchasePriceLimit(data.data),
    }
  }, [data])

  return {
    data: { purchasePriceLimit },
    states: { isFetching },
  }
}
